import PropTypes from "prop-types"
// import { useQuery } from "@apollo/client"
import Select from "components/InputMUI/Select"
// import { productsQuery } from "./query"
import { FormattedMessage } from "react-intl"
import { PRODUCT_MSGS } from "../../constants"
import { DISCONTINUED_STYLES } from "./constants"
import { handleOrderArray } from "./utils"
import { PATTERNS_EU } from "../PatternField/constants"

const ProductField = ({ name, control, label, placeholder, defaultValue, error, pattern }) => {
  let options = []
  if (pattern) {
    const colorsByPattern = PATTERNS_EU.filter(({ value }) => value === pattern)
    // const { data, loading } = useQuery(productsQuery, { variables: { pattern } })
    // const options = data?.products.edges.map(
    options = colorsByPattern[0].colors.map(({ label, value, isDiscontinued = false }) => ({
      label: !isDiscontinued ? (
        label
      ) : (
        <FormattedMessage {...PRODUCT_MSGS.discontinued} values={{ color: label }} />
      ),
      value,
      isDiscontinued
    }))
  }

  return (
    <Select
      customStyles={DISCONTINUED_STYLES}
      name={name}
      control={control}
      label={label}
      placeholder={placeholder}
      options={handleOrderArray(options)}
      areDrawOptions
      defaultValue={defaultValue}
      // disabled={loading || !pattern}
      disabled={!pattern}
      error={error}
    />
  )
}

ProductField.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  label: PropTypes.object.isRequired,
  placeholder: PropTypes.object,
  disabled: PropTypes.bool,
  defaultValue: PropTypes.string,
  error: PropTypes.string,
  pattern: PropTypes.string
}

export default ProductField
